<div class="w-full bg-gray-50 px-4 pt-16 pb-20 lg:pt-24 lg:pb-28">

    <div class="w-full">
        <div class="flex flex-col justify-center items-center text-center">
            <h2 class="text-3xl font-bold tracking-tight text-gray-900 sm:text-4xl">
                {{view.pageTitle}}
            </h2>
            <p class="mt-3 max-w-2xl text-xl text-gray-500 sm:mt-4">
                {{view.pageDescription}}
            </p>
        </div>

        <!-- Loading State -->
        @if (view.isLoading) {
        <div
            class="flex justify-center items-center space-x-1 text-primary-500 font-accent tracking-widest text-4xl mt-15">
            <span class="animate-bounce-0">L</span>
            <span class="animate-bounce-1">o</span>
            <span class="animate-bounce-2">a</span>
            <span class="animate-bounce-3">d</span>
            <span class="animate-bounce-4">i</span>
            <span class="animate-bounce-5">n</span>
            <span class="animate-bounce-6">g</span>
        </div>
        }

        @if(!view.isLoading) {
        <div class="mt-12 grid grid-cols-1 gap-3 md:grid-cols-3 xl:grid-cols-4 w-full px-32">
            @for (blog of view.page; track blog) {
            <fuse-card class="flex flex-col overflow-hidden rounded-lg shadow-lg w-full">
                @if (blog.imageUrl || blog.imageUrlRaw) {
                <img [src]="blog.imageUrlRaw || blog.imageUrl" [alt]="blog.title" class="w-full h-48 object-cover" />
                }
                <span
                    class="absolute top-3 left-3 bg-primary-500 text-white tracking-widest text-md font-semibold px-3 py-1 rounded-full shadow-md">
                    {{ blog.tags || 'Travel' }}
                </span>
            
                <div class="p-4 flex flex-col justify-between h-full">
                    <div>
                        <h3 class="text-lg font-semibold text-gray-800 mb-2">
                            {{ blog.name }}
                        </h3>
                        <p class="text-sm text-gray-600 line-clamp-3" [innerHTML]="blog.rawContentShort"></p>
                    </div>
            
                    <div class="flex justify-between items-center mt-4">
                        <div class="flex items-center gap-2">
                            <img [src]="blog.authorImage || 'assets/images/avatars/user.png'" [alt]="blog.author"
                                class="w-8 h-8 rounded-full" />
                            <div class="text-xs text-gray-500">
                                <!-- <p>{{ blog.author }}</p> -->
                                <p>{{ blog.createdOn | date: 'MMMM d, y' }}</p>
                            </div>
                        </div>
            
                        <button class="flex items-center gap-1 text-primary-600 hover:text-primary-800 text-sm font-medium"
                            (click)="openBlogModal(blog)">
                            <span class="flex items-center">Read More</span>
                            <mat-icon svgIcon="heroicons_outline:chevron-double-right"
                                class="text-base flex items-center"></mat-icon>
                        </button>
                    </div>
                </div>
            </fuse-card>
            }
        </div>
        }
    </div>
</div>

<!-- Blog Modal -->
@if(selectedBlog) {
<div class="fixed inset-0 bg-black bg-opacity-50 z-9999 overflow-y-auto">
    <div class="min-h-full flex items-center justify-center p-4">
        <div class="bg-white rounded-xl max-w-2xl w-full mx-4 shadow-lg relative max-h-[calc(100vh-2rem)] overflow-y-auto">
            <button class="absolute top-3 right-3" (click)="closeBlogModal()">
                <mat-icon class="text-black" svgIcon="mat_solid:close"></mat-icon>
            </button>
            @if (selectedBlog.imageUrl || selectedBlog.imageUrlRaw) {
            <img [src]="selectedBlog.imageUrlRaw || selectedBlog.imageUrl" [alt]="selectedBlog.title"
                class="w-full h-56 object-cover rounded-t-xl" />
            }
            <div class="p-6">
                <h2 class="text-xl font-semibold mb-2 text-gray-800"> {{ selectedBlog.name }} </h2>
                <p class="text-sm text-gray-600 mb-4" [innerHTML]="selectedBlog.rawContent"> </p>
                <div class="flex justify-between items-center mt-4">
                    <div class="flex items-center gap-2">
                        <img [src]="selectedBlog.authorImage || 'assets/images/avatars/user.png'" [alt]="selectedBlog.author"
                            class="w-8 h-8 rounded-full" />
                        <div class="text-xs text-gray-500">
                            <!-- <p>{{ selectedBlog.author }}</p> -->
                            <p>{{ selectedBlog.createdOn | date: 'MMMM d, y' }}</p>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</div>
}
